import {
  CategoryType,
  ConcertGenre,
  DocumentaryGenre,
  Language,
  MovieClassification,
  MovieGenre,
  Quality, UserRole
} from '@/types';

export const classificationOptions = [
  { value: 'G', label: 'G - General Audiences' },
  { value: 'PG', label: 'PG - Parental Guidance' },
  { value: 'PG_13', label: 'PG-13 - Parents Strongly Cautioned' },
  { value: 'R', label: 'R - Restricted' },
  { value: 'NC_17', label: 'NC-17 - Adults Only' },
  { value: 'NR', label: 'NR - Not Rated' }
];

export const categoryTypes: CategoryType[] = [
  'MOVIE',
  'TV_SHOW',
  'DOCUMENTARY',
  'SPORTS',
  'MUSIC',
  'TV_CHANNEL',
  'RADIO_STATION',
];

export const qualityTypes: Quality[] = [
  'SD',
  'HD',
  'FHD',
  '4K'
];

export const documentaryGenres: DocumentaryGenre[] = [
  'ARTE_Y_MUSICA',
  'BIOGRAFIA',
  'CIENCIA',
  'COMEDIA',
  'CONSPIRACION',
  'CRIMEN',
  'DROGAS',
  'ECONOMIA',
  'FILOSOFIA',
  'DEPORTES',
  'HISTORIA',
  'MEDIO_AMBIENTAL',
  'MEDIOS',
  'MILITAR_Y_GUERRA',
  'MISTERIO',
  'NATURALEZA',
  'POLITICA',
  'PSICOLOGIA',
  'RELIGION',
  'SALUD',
  'SEXUALIDAD',
  'SOCIEDAD',
  'TECNOLOGIA',
  'VIAJES',
]


export const languages: Language[] = [
  'SPANISH',
  'ENGLISH',
  'FRENCH',
  'GERMAN',
  'ITALIAN',
  'PORTUGUESE',
  'CATALAN',
  'JAPANESE',
  'KOREAN',
  'MANDARIN',
  'RUSSIAN',
  'ARABIC',
  'HINDI',
  'TURKISH',
  'DUTCH',
  'SWEDISH',
  'NORWEGIAN',
  'DANISH',
  'THAI',
  'POLISH',
  'FINNISH',
  'GREEK',
  'HEBREW',
  'BULGARIAN',
  'CZECH',
  'HUNGARIAN',
  'ROMANIAN'
];

export const movieClassifications: MovieClassification[] = [
  'G',
  'PG',
  'PG_13',
  'R',
  'NC_17',
  'NR',
  'XXX'
];

export const sportsGenreOptions = [
  { value: 'AEROBICO', label: 'Aeróbico' },
  { value: 'AERODROMO', label: 'Aeródromo' },
  { value: 'AJEDREZ', label: 'Ajedrez' },
  { value: 'ALA_DELTA', label: 'Ala Delta' },
  { value: 'ALPINISMO', label: 'Alpinismo' },
  { value: 'ARTES_MARCIALES', label: 'Artes Marciales' },
  { value: 'ATLETISMO', label: 'Atletismo' },
  { value: 'AUTOMOVILISMO', label: 'Automovilismo' },
  { value: 'BADMINTON', label: 'Bádminton' },
  { value: 'BALONCESTO', label: 'Baloncesto' },
  { value: 'BEISBOL', label: 'Béisbol' },
  { value: 'BOXEO', label: 'Boxeo' },
  { value: 'CICLISMO', label: 'Ciclismo' },
  { value: 'ESCALADA', label: 'Escalada' },
  { value: 'ESGRIMA', label: 'Esgrima' },
  { value: 'ESQUI', label: 'Esquí' },
  { value: 'FUTBOL', label: 'Fútbol' },
  { value: 'FUTBOL_AMERICANO', label: 'Fútbol Americano' },
  { value: 'GIMNASIA', label: 'Gimnasia' },
  { value: 'GOLF', label: 'Golf' },
  { value: 'HOCKEY', label: 'Hockey' },
  { value: 'LUCHA_LIBRE', label: 'Lucha Libre' },
  { value: 'NATACION', label: 'Natación' },
  { value: 'MOTOCICLISMO', label: 'Motociclismo' },
  { value: 'PARACAIDISMO', label: 'Paracaidismo' },
  { value: 'RUGBY', label: 'Rugby' },
  { value: 'SURF', label: 'Surf' },
  { value: 'TENIS', label: 'Tenis' },
  { value: 'VOLLEYBALL', label: 'Voleibol' },
  { value: 'WATERPOLO', label: 'Waterpolo' }
];

export const qualityOptions: {value: Quality, label: string}[] = [
  { value: 'SD', label: 'SD (480p)' },
  { value: 'HD', label: 'HD (720p)' },
  { value: 'FHD', label: 'Full HD (1080p)' },
  { value: '4K', label: '4K (2160p)' }
];

export const languageOptions: {value: Language, label: string}[] = [
  { value: 'SPANISH', label: 'Español' },
  { value: 'ENGLISH', label: 'Inglés' },
  { value: 'FRENCH', label: 'Francés' },
  { value: 'GERMAN', label: 'Alemán' },
  { value: 'ITALIAN', label: 'Italiano' },
  { value: 'PORTUGUESE', label: 'Portugués' },
  { value: 'CATALAN', label: 'Catalán' },
  { value: 'JAPANESE', label: 'Japonés' },
  { value: 'KOREAN', label: 'Coreano' },
  { value: 'MANDARIN', label: 'Chino' },
  { value: 'RUSSIAN', label: 'Ruso' },
  { value: 'ARABIC', label: 'Árabe' },
  { value: 'HINDI', label: 'Hindi' },
  { value: 'TURKISH', label: 'Turco' },
  { value: 'DUTCH', label: 'Holandés' },
  { value: 'SWEDISH', label: 'Sueco' },
  { value: 'NORWEGIAN', label: 'Noruego' },
  { value: 'DANISH', label: 'Danés' },
  { value: 'THAI', label: 'Tailandés'},
  { value: 'BULGARIAN', label: 'Búlgaro'},
  { value: 'CZECH', label: 'Checo'},
  { value: 'FINNISH', label: 'Finlandés'},
  { value: 'HEBREW', label: 'Hebreo'},
  { value: 'GREEK', label: 'Griego'},
  { value: 'ROMANIAN', label: 'Rumano'},
  { value: 'POLISH', label: 'Polaco'}
];

export const movieGenreOptions: {value: MovieGenre, label: string}[] = [
  { value: 'ACTION', label: 'Acción' },
  { value: 'ADVENTURE', label: 'Aventura' },
  { value: 'ANIMATION', label: 'Animación' },
  { value: 'BIOGRAPHY', label: 'Biografía' },
  { value: 'COMEDY', label: 'Comedia' },
  { value: 'CRIME', label: 'Crimen' },
  { value: 'DOCUMENTARY', label: 'Documental' },
  { value: 'DRAMA', label: 'Drama' },
  { value: 'FAMILY', label: 'Familiar' },
  { value: 'FANTASY', label: 'Fantasía' },
  { value: 'HISTORY', label: 'Historia' },
  { value: 'HORROR', label: 'Horror' },
  { value: 'MUSIC', label: 'Música' },
  { value: 'MUSICAL', label: 'Musical' },
  { value: 'MYSTERY', label: 'Misterio' },
  { value: 'ROMANCE', label: 'Romance' },
  { value: 'SCI_FI', label: 'Ciencia Ficción' },
  { value: 'THRILLER', label: 'Suspenso' },
  { value: 'WAR', label: 'Guerra' },
  { value: 'WESTERN', label: 'Western' }
];

export const movieClassificationOptions:{value: MovieClassification, label: string}[] = [
  { value: 'G', label: 'G - General Audiences' },
  { value: 'PG', label: 'PG - Parental Guidance' },
  { value: 'PG_13', label: 'PG-13 - Parents Strongly Cautioned' },
  { value: 'R', label: 'R - Restricted' },
  { value: 'NC_17', label: 'NC-17 - Adults Only' },
  { value: 'NR', label: 'NR - Not Rated' },
  { value: 'XXX', label: 'XXX' }
];

export const concertGenreOptions: {value: ConcertGenre, label: string}[] = [
  //read all the concert genres from the enum ConcertGenre
  { value: 'BACHATA', label: 'Bachata' },
  { value: 'BALADA', label: 'Balada' },
  { value: 'BATUCADA', label: 'Batucada' },
  { value: 'BOLERO', label: 'Bolero' },
  { value: 'CLASICA', label: 'Clásica' },
  { value: 'COUNTRY', label: 'Country' },
  { value: 'CRISTIANA', label: 'Cristiana' },
  { value: 'CUMBIA', label: 'Cumbia' },
  { value: 'DANCE', label: 'Dance' },
  { value: 'DISCO', label: 'Disco' },
  { value: 'DURANGUENSE', label: 'Duranguense' },
  { value: 'ELECTRONICA', label: 'Electrónica' },
  { value: 'EMO', label: 'Emo' },
  { value: 'FLAMENCO', label: 'Flamenco' },
  { value: 'FOLK', label: 'Folk' },
  { value: 'FUNK', label: 'Funk' },
  { value: 'GOSPEL', label: 'Gospel' },
  { value: 'GRUPERA', label: 'Grupera' },
  { value: 'HIP_HOP', label: 'Hip Hop' },
  { value: 'INFANTILES', label: 'Infantiles' },
  { value: 'INSTRUMENTALES', label: 'Instrumentales' },
  { value: 'JAZZ', label: 'Jazz' },
  { value: 'LAMBADA', label: 'Lambada' },
  { value: 'MERENGUE', label: 'Merengue' },
  { value: 'MERENGUE_TIPICO', label: 'Merengue Típico' },
  { value: 'METAL', label: 'Metal' },
  { value: 'NORTEÑA', label: 'Norteña' },
  { value: 'OPERA', label: 'Ópera' },
  { value: 'POP', label: 'Pop' },
  { value: 'PUNK', label: 'Punk' },
  { value: 'R_B', label: 'R&B' },
  { value: 'RANCHERA', label: 'Ranchera' },
  { value: 'RAP', label: 'Rap' },
  { value: 'REGGAE', label: 'Reggae' },
  { value: 'REGGAETON', label: 'Reggaeton' },
  { value: 'ROCK', label: 'Rock' },
  { value: 'ROMANTICA', label: 'Romántica' },
  { value: 'SALSA', label: 'Salsa' },
  { value: 'SAMBA', label: 'Samba' },
  { value: 'SOUL', label: 'Soul' },
  { value: 'SOUND_TRACKS', label: 'Sound Tracks' },
  { value: 'TECHNO', label: 'Techno' },
  { value: 'TRANCE', label: 'Trance' },
  { value: 'TRAP', label: 'Trap' },
  { value: 'TROVA', label: 'Trova' },
  { value: 'TANGO', label: 'Tango' },
  { value: 'VALLENATO', label: 'Vallenato' }
];

// TV Show Options
export const tvShowGenreOptions = [
  { value: 'ACTION', label: 'Acción' },
  { value: 'ADVENTURE', label: 'Aventura' },
  { value: 'ANIMATION', label: 'Animación' },
  { value: 'BIOGRAPHY', label: 'Biografía' },
  { value: 'COMEDY', label: 'Comedia' },
  { value: 'CRIME', label: 'Crimen' },
  { value: 'DOCUMENTARY', label: 'Documental' },
  { value: 'DRAMA', label: 'Drama' },
  { value: 'FAMILY', label: 'Familiar' },
  { value: 'FANTASY', label: 'Fantasía' },
  { value: 'FILM_NOIR', label: 'Film Noir' },
  { value: 'HISTORY', label: 'Historia' },
  { value: 'HORROR', label: 'Horror' },
  { value: 'MUSIC', label: 'Música' },
  { value: 'MUSICAL', label: 'Musical' },
  { value: 'MYSTERY', label: 'Misterio' },
  { value: 'ROMANCE', label: 'Romance' },
  { value: 'RETRO', label: 'Retro' },
  { value: 'SCI_FI', label: 'Ciencia Ficción' },
  { value: 'SPORT', label: 'Deportes' },
  { value: 'THRILLER', label: 'Suspenso' },
  { value: 'WAR', label: 'Guerra' },
  { value: 'WESTERN', label: 'Western' },
  { value: 'XXX', label: 'XXX' },
  { value: 'REALITY', label: 'Reality' },
  { value: 'TALK_SHOW', label: 'Talk Show' },
  { value: 'NEWS', label: 'Noticias' },
  { value: 'SOAP_OPERA', label: 'Telenovela' }
];

export const tvShowClassificationOptions = [
  { value: 'G', label: 'G - General Audiences' },
  { value: 'PG', label: 'PG - Parental Guidance' },
  { value: 'PG_13', label: 'PG-13 - Parents Strongly Cautioned' },
  { value: 'TV_14', label: 'TV-14 - Unsuitable for children under 14' },
  { value: 'TV_MA', label: 'TV-MA - Mature Audiences Only' },
  { value: 'NR', label: 'NR - Not Rated' }
];

export const tvShowStatusOptions = [
  { value: 'RUNNING', label: 'En emisión' },
  { value: 'ENDED', label: 'Finalizada' },
  { value: 'CANCELLED', label: 'Cancelada' },
  { value: 'ON_HIATUS', label: 'En pausa' },
  { value: 'PLANNED', label: 'Planeada' }
];


export const userRoleValues: UserRole[] = ['app','agent', 'admin', 'superadmin', 'contentManager'];
